var InformationController = function() {
    this.getScrollScene = require('../module/getScrollScene');
    this.init();
};

InformationController.prototype = {
    init: function() {
        //scene controller
        var controller = new ScrollMagic();
        //scene option
        var option = {
            triggerElement: 'h1',
            triggerHook: 'onLeave',
            offset: $('#js-globalHeader').height() * -1,
            reverse: true
        };

        var scene = this.getScrollScene(controller, option);

        require('../module/scene-globalHeader')(scene);

        var loadHandler = function(){
            if ($('.information-wrapper').length > 0) {
                var windowHeight = $(window).height();
                var wrapperHeight = $('.information-wrapper').height();

                if (windowHeight > wrapperHeight) {
                    $('.information-wrapper').height(windowHeight);
                }

            } else if ($('.about-wrapper').length > 0) {
                var windowHeight = $(window).height();
                var wrapperHeight = $('.about-wrapper').height();

                if (windowHeight > wrapperHeight) {
                    $('.about-wrapper').height(windowHeight);
                }
            }
        }
        $window.on('load', loadHandler);
    }
};

module.exports = InformationController;



/** WEBPACK FOOTER **
 ** ./src/pc/assets/js/controller/InformationController.js
 **/